import { css, type CSSObject, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { position, rem } from 'polished'

import { highContrast } from '@Styles/a11y'
import { RADIUS_0 } from '@Styles/constants/radius'

import { BORDER_SIZE, FOCUS_OFFSET } from './focus'

const focusVisibleOffset = css({
  bottom: `calc(${FOCUS_OFFSET} + ${BORDER_SIZE})`,
})

export const selectionAccessibilityBar = (theme: Theme, forceFocusVisible = false): SerializedStyles =>
  css(
    highContrast({ border: 'solid 2px transparent' }),
    {
      '&::after': {
        backgroundColor: theme.palette.primary.contrastText,
        borderRadius: `${RADIUS_0} ${RADIUS_0} 0 0`,
        content: "''",
        height: rem(2),
        margin: 'auto',
        width: rem(24),
        ...position('absolute', null, 0, 0, 0),
        ...highContrast({ backgroundColor: 'Highlight' }),
      } as CSSObject,
      '&:focus-visible::after': focusVisibleOffset,
    },
    forceFocusVisible && {
      '&::after': focusVisibleOffset,
    },
  )
